/*
 * dos-terminal.js — an interactive MS-DOS prompt for the DOS C:\GAMES> hat.
 *
 * sections/dos-terminal.liquid injects the product info as window.DOS_PRODUCT
 * { title, price, description, addUrl } and provides the markup:
 *   #dos-terminal > #dos-output (log) + #dos-line (prompt + #dos-input)
 *
 * Self-hosted, no dependencies.
 */
(function () {
  "use strict";

  var term = document.getElementById("dos-terminal");
  var out = document.getElementById("dos-output");
  var input = document.getElementById("dos-input");
  if (!term || !out || !input) return;

  var P = window.DOS_PRODUCT || {};
  var PROMPT = "C:\\GAMES>";

  function line(text, cls) {
    var div = document.createElement("div");
    div.className = "dos-row" + (cls ? " " + cls : "");
    div.textContent = text == null ? "" : text;
    out.appendChild(div);
    term.scrollTop = term.scrollHeight;
    return div;
  }

  // Type text out character-by-character (for the boot sequence).
  function typeLines(lines, done) {
    var i = 0;
    (function next() {
      if (i >= lines.length) { if (done) done(); return; }
      var row = line("", "dos-boot");
      var text = lines[i++], c = 0;
      var iv = setInterval(function () {
        row.textContent = text.slice(0, ++c);
        term.scrollTop = term.scrollHeight;
        if (c >= text.length) { clearInterval(iv); setTimeout(next, 90); }
      }, 9);
    })();
  }

  var FILES = ["PRODUCT.TXT", "README.TXT", "ADDCART.EXE", "AUTOEXEC.BAT", "CONFIG.SYS"];

  var COMMANDS = {
    HELP: function () {
      line("Available commands:");
      line("  DIR              list files in C:\\GAMES");
      line("  TYPE <file>      display a file (try TYPE PRODUCT.TXT)");
      line("  BUY / ADDCART    add this item to your cart");
      line("  VER              MS-DOS version");
      line("  CLS              clear the screen");
      line("  HELP             this list");
    },
    DIR: function () {
      line(" Volume in drive C is ABANDONWARE");
      line(" Directory of C:\\GAMES");
      line("");
      FILES.forEach(function (f) {
        var name = f.split(".")[0], ext = f.split(".")[1];
        line(pad(name, 9) + pad(ext, 4) + "        " + "01-01-2000  12:00a");
      });
      line("        " + FILES.length + " file(s)");
    },
    TYPE: function (arg) {
      var f = (arg || "").toUpperCase();
      if (f === "PRODUCT.TXT") {
        line(P.title || "Mystery Product", "dos-bright");
        if (P.price) line("Price: " + P.price, "dos-bright");
        line("");
        (P.description || "No description available.")
          .replace(/\s+/g, " ").trim()
          .match(/.{1,58}(\s|$)/g)
          .forEach(function (l) { line(l.trim()); });
        line("");
        line("Type BUY to add to cart.", "dos-bright");
      } else if (f === "README.TXT") {
        line("Thank you for choosing Abandonware(tm).");
        line("This software is no longer supported. Neither are we.");
      } else if (f === "AUTOEXEC.BAT") {
        line("@ECHO OFF");
        line("PROMPT $P$G");
        line("C:\\GAMES\\NOSTALGIA.EXE /FOREVER");
      } else if (f === "CONFIG.SYS") {
        line("DEVICE=HIMEM.SYS");
        line("FILES=30");
        line("DEVICE=VIBES.SYS /ETERNAL");
      } else if (f === "ADDCART.EXE" || f === "") {
        line(f ? "Cannot TYPE a binary file. Run BUY instead." : "Required parameter missing.");
      } else {
        line("File not found - " + (arg || ""));
      }
    },
    BUY: function () { addToCart(); },
    ADDCART: function () { addToCart(); },
    "ADDCART.EXE": function () { addToCart(); },
    VER: function () {
      line("MS-DOS Version 6.22  [Abandonware Edition]");
    },
    CLS: function () { out.innerHTML = ""; },
    // easter eggs
    WIN: function () { line("Windows is for quitters. Stay in DOS."); },
    "FORMAT": function () { line("Nice try. C: is write-protected by nostalgia."); },
    DOOM: function () { line("Knee-Deep in the Dead... (not included)"); }
  };

  function pad(s, n) { s = String(s); while (s.length < n) s += " "; return s; }

  function addToCart() {
    var form = document.querySelector('form[action*="/cart/add"], product-form form');
    line("Running ADDCART.EXE...");
    if (form) {
      line("Item added to cart. Loading...", "dos-bright");
      setTimeout(function () { try { form.requestSubmit ? form.requestSubmit() : form.submit(); } catch (e) {} }, 600);
    } else if (P.addUrl) {
      line("Redirecting to checkout...", "dos-bright");
      setTimeout(function () { window.location.href = P.addUrl; }, 600);
    } else {
      line("ERROR: cart subsystem not found.");
    }
  }

  function run(raw) {
    var cmd = raw.trim();
    line(PROMPT + " " + cmd, "dos-echo");
    if (!cmd) return;
    var parts = cmd.split(/\s+/);
    var name = parts[0].toUpperCase();
    var fn = COMMANDS[name];
    if (fn) fn(parts.slice(1).join(" "));
    else line("Bad command or file name");
  }

  input.addEventListener("keydown", function (e) {
    if (e.key === "Enter") {
      var v = input.value;
      input.value = "";
      run(v);
    }
  });

  // Keep focus on the prompt; clicking anywhere in the terminal refocuses.
  term.addEventListener("click", function () { input.focus(); });

  // Boot sequence, then hand over to the prompt.
  typeLines(
    [
      "Abandonware BIOS v6.22  (C) 2000",
      "Detecting nostalgia............ OK",
      "HIMEM.SYS installed.",
      "Starting MS-DOS...",
      "",
      "C:\\GAMES> Type HELP for commands, or TYPE PRODUCT.TXT"
    ],
    function () {
      document.getElementById("dos-line").style.display = "flex";
      input.focus();
    }
  );
})();
